import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const ReleaseComponent = lazy(() => import('./release.tsx'));

export const releaseRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <ReleaseComponent />
      </Suspense>
    )
  }
];
